import { TextShout, RaiseHandShout, Shout } from '@/store/types/stageState';

export class RaiseHand {
  static REGEX = /:\/raise_hand-(true|false)\/:/gm;

  static isShoutRaiseHand(shout: Shout): shout is RaiseHandShout {
    return Object.prototype.hasOwnProperty.call(shout, 'raised');
  }

  static isRaisedHand(shout: Shout) {
    if (this.isShoutRaiseHand(shout)) return shout.raised;
    const splited = shout.message.split(this.REGEX);
    return splited[1] === 'true';
  }

  static isRaiseHand(shout: Shout) {
    if (this.isShoutRaiseHand(shout)) return true;
    const splited = shout.message.split(this.REGEX);
    if (splited.length === 3) {
      return splited[1] === 'true' || splited[1] === 'false';
    } else {
      return false;
    }
  }

  static TextShoutToRaiseHand(shout: TextShout): RaiseHandShout {
    return {
      raised: this.isRaisedHand(shout),
      user: shout.user,
      time: shout.time,
    };
  }
}
